import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BillPaymentStatusEnum } from '@zaoblako/shared/modules/document/enums/bill.payment.status.enum';
import { BillPaymentStatusEnumI18n } from '@zaoblako/shared/modules/document/i18n/bill.payment.status.enum.i18n';

@Pipe({
  name: 'billPaymentStatusName',
  standalone: true
})
export class BillPaymentStatusNamePipe implements PipeTransform {
  public transform(status: BillPaymentStatusEnum): string {
    return BillPaymentStatusEnumI18n[I18nLocalesEnum.RU_RU][status] || '';
  }
}
